import { Zap } from "lucide-react";
import { StatRail } from "./StatRail";
import { Generator } from "./Generator";
import { AdminTestBandwidth } from "./AdminTestBandwidth";

export function HomeTab({ user, load, totalRemaining, usedGb, usage, accounts, ispOrders, pools, config, setTab }) {
  return (
    <div className="space-y-6">
      {user?.role === "admin" && <AdminTestBandwidth onDone={load} />}
      <StatRail totalRemaining={totalRemaining} usedGb={usedGb} usage={usage} accounts={accounts} ispOrders={ispOrders} />
      <div className="bg-white border border-[#E4EEEC] rounded-3xl p-6 shadow-sm">
        <div className="flex items-center gap-2 mb-5"><Zap className="w-5 h-5 text-neon" aria-hidden="true" /><h2 className="font-head text-lg font-semibold text-ink">Proxy Generator</h2></div>
        <Generator accounts={accounts} pools={pools} config={config} goShop={() => setTab("resi")} />
      </div>
    </div>
  );
}
